import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import PropTypes from 'prop-types';
import './FilterPanel.css';

export default class FilterPanel extends Component {
  static propTypes = {
    addTopMargin: PropTypes.bool
  };
  
  static defaultProps = {
    addTopMargin: true
  };
  
  state = {
    filter: false
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      filter: nextProps.filter
    })
  }

  _handleSetFilter = (filter) => {
    const { onChange } = this.props;
    this.setState({
      filter
    });
    onChange(filter);
  };

  render() {
    const { addTopMargin } = this.props;
    const { filter } = this.state;
    
    return (
      <Row middle="xs" className={`filter-panel ${addTopMargin ? 'mt-30' : ''} mb-30`}>
        <Col xs={12}>
          <div className="btn-group filter-group">
            <button className={`btn btn-primary ${filter === 'photo' ? 'active' : ''}`} onClick={() => {
              this._handleSetFilter('photo')
            }}>Photos
            </button>
            <button className={`btn btn-primary ${filter === 'Issues' ? 'active' : ''}`} onClick={() => {
              this._handleSetFilter('Issues')
            }}>Issue reports
            </button>
            <button className={`btn btn-primary ${filter === 'Checklists' ? 'active' : ''}`} onClick={() => {
              this._handleSetFilter('Checklists')
            }}>Checklist reports
            </button>
            {/* <button className={`btn btn-primary ${filter === 'Specs' ? 'active' : ''}`} onClick={() => {
              this._handleSetFilter('Specs')
            }}>Specs
            </button> */}
            {/*<button className={`btn btn-primary ${filter === 'Plans' ? 'active' : ''}`} onClick={() => {*/}
            {/*  this._handleSetFilter('Plans')*/}
            {/*}}>Files*/}
            {/*</button>*/}
            {/* <button className={`btn btn-primary ${filter === 'General' ? 'active' : ''}`} onClick={() => {
              this._handleSetFilter('General')
            }}>General files
            </button> */}
            <button className={`btn btn-primary ${!filter ? 'active' : ''}`} onClick={() => {
              this._handleSetFilter(false)
            }}>All files
            </button>
          </div>
        </Col>
      </Row>
    );
  }
}

FilterPanel.propTypes = {
  filter: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onChange: PropTypes.func.isRequired
};
